import { EBrandCode, IBrand, ILanguage } from "./types";
// View Models
export const SIGNUP_VIEW_MODEL = "signup:view-model";
export const USER_DETAILS_VIEW_MODEL = "user-details:view-model";
export const COMPANY_DETAILS_VIEW_MODEL = "company-details:view-model";
export const CHECKOUT_VIEW_MODEL = "payment-details:view-model";
export const PRODUCT_DETAILS_VIEW_MODEL = "product-details:view-model";
export const PAYMENT_LANDING_VIEW_MODEL = "payment-landing:view-model";
export const WIZARD_VIEW_MODEL = "wizard:view-model";
export const RELATIONS_VIEW_MODEL = "relations:view-model";
export const OPT_OUT_VIEW_MODEL = "opt-out:view-model";
export const SECURE_PAYMENT_VIEW_MODEL = "secure-payment:view-model";
// Defaults
export const DEFAULT_COMMUNITY_ACCOUNT_ID = +window.appConfig.communityAccountId;
export const DEFAULT_LANGUAGE: ILanguage = {
  id: 1,
  code: "en",
  label: "English"
};

export const DEFAULT_BRANDS: IBrand[] = [
  {
    code: EBrandCode.Constructionline,
    name: "Constructionline"
  },
  {
    code: EBrandCode.BuildersProfile,
    name: "Builder's Profile"
  },
  {
    code: EBrandCode.Facilitiesline,
    name: "Facilitiesline"
  }
];
export const MARKETPLACE_SALES_TYPE_ID = 512;
export const SIGNUP_EMAIL_SESSION_KEY = "signup:email";
export const SIGNUP_LANGUAGE_SESSION_KEY = "signup:language";
export const SIGNUP_SESSION_ID_SESSION_KEY = "signup:sessionId";
export const SIGNUP_COMPLETE_SESSION_KEY = "signup:complete";
export const SIGNUP_COMMUNITY_ACCOUNT_ID_SESSION_KEY = "signup:communityAccountId";
export const SIGNUP_INVITE_LOOKUP_DONE_SESSION_KEY = "signup:inviteLookupDone";
export const SIGNUP_ERROR_PAGE_URL = "/error";
export const WIZARD_NAVIGATION_BACK_HISTORY_SESSION_KEY = "wizard:navigation-back-history";
export const SELECTED_COMPANY_SEARCH_SESSION_KEY = "company-details:selectedCompanySearch";
export const SIGNUP_CHANNEL_SESSION_KEY = "signup:channel";
export const SIGNUP_COMMUNITY_ID_SESSION_KEY = "signup:community-id";

export const viewPortBp = {
  xl: 1024,
  l: 968,
  m: 784,
  s: 578
};

export const viewPortBpPx = {
  xl: "1024px",
  l: "968px",
  m: "784px",
  s: "578px"
};
